import { Table } from '@tanstack/react-table';
import { NoddiIcon } from 'noddi-ui-common';
import { Button } from '../../../../base/button/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger
} from '../../../../base/dropdown-menu';
import { resolveTableViewTranslations, TableViewTranslations } from '../tableTranslationTypes';

interface ViewToggleProps<TData> {
  table: Table<TData>;
  translations?: {
    view?: Partial<TableViewTranslations>;
  };
}

export function ViewToggle<TData>({ table, translations }: ViewToggleProps<TData>) {
  const viewTexts = resolveTableViewTranslations(translations?.view);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='outline'>
          <NoddiIcon name='Settings2' />
          {viewTexts.view}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-50'>
        <DropdownMenuLabel>{viewTexts.columns}</DropdownMenuLabel>
        {table
          .getAllColumns()
          .filter((column) => column.getCanHide())
          .map((column) => {
            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className='capitalize'
                checked={column.getIsVisible()}
                onCheckedChange={(value) => column.toggleVisibility(!!value)}
              >
                {typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id}
              </DropdownMenuCheckboxItem>
            );
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
